export const NAME = 'auth';



// WEBPACK FOOTER //
// ./src/modules/auth/constants.js